import styled, { css } from 'styled-components';

import { size } from '../../layout/helpers';
import { ButtonReset } from '../../layout/reset';

export type IconButtonSizeProps = 'small';

interface WrapperProps {
  $size?: IconButtonSizeProps;
}

export const Wrapper = styled(ButtonReset)<WrapperProps>`
  --_bg: var(--c-bg-main);

  flex-shrink: 0;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--icon-button-size);
  height: var(--icon-button-size);
  border-radius: ${size(1)};
  border: 1px solid var(--c-input-border);
  background-color: var(--_bg);
  color: var(--c-text-main);
  transition: transform 200ms ease;
  transform-origin: 50% 50%;

  &:enabled {
    &:active {
      transform: scale(0.95);
    }

    &:hover {
      border-color: var(--c-input-border-active);
    }
  }

  &[disabled] {
    opacity: 0.37;
    cursor: not-allowed;
  }

  ${({ $size }) =>
    $size === 'small'
      ? css`
    --icon-button-size: ${size(4)};
  `
      : undefined}
`;
